export const createUISlice = (set, get) => ({
  // UI state
  sidebarOpen: true,
  theme: 'dark',
  loading: false,
  galleryVisible: true,
  editMode: false,
  sliderVisible: false,
  currentMaskUrl: null,
  maskPreviewVisible: false,
  maskPreviewOpacity: 0.35,

  // UI actions
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setTheme: (theme) => set({ theme }),
  setLoading: (loading) => set({ loading }),
  setGalleryVisible: (visible) => set({ galleryVisible: visible }),
  setEditMode: (mode) => set({ editMode: mode }),
  setSliderVisible: (visible) => set({ sliderVisible: visible }),
  setCurrentMask: (url) => set({ currentMaskUrl: url })
  ,setMaskPreviewVisible: (v)=> set({ maskPreviewVisible: v })
  ,setMaskPreviewOpacity: (v)=> set({ maskPreviewOpacity: v })
})